import React, { useEffect, useState } from "react";
import Link from "next/link";
import Calender from "../assets/Calender";
import Arrow from "../assets/Arrow";
import Bag from "../assets/Bag";
import { useRouter } from "next/router";
import { useTranslations } from "next-intl";

const CareerCard = ({ job }) => {
  const t = useTranslations("careerCard");
  const [date, setDate] = useState();
  const { locale } = useRouter();
  const dateFormat = (date) => {
    const newDate = new Date(date);
    return new Intl.DateTimeFormat(`${locale}-gb`, {
      day: "numeric",
      month: "long",
      year: "numeric",
    }).format(newDate);
  };

  useEffect(() => {
    setDate(dateFormat(job.date));
  }, [locale]);

  return (
    <div
      className={` h-[205px] overflow-hidden border-2 border-[#CECED8] rounded-[15px] pl-[38px] pr-[18px] flex items-start flex-col  justify-center col-span-12  md:col-span-6  xl:col-span-4 min-w-[300px] w-auto  sm:w-auto bg-[rgba(246,246,246,0.5)] `}
      key={job._id}
    >
      {/* job title  */}
      <div>
        <h5 className="font-[590] truncate text-[24px] pb-2 leading-[26px] text-[#010140]">
          {job.position || job[locale].position}
        </h5>
        <p className="text-[18px] text-[#6D2E88] truncate  leading-[26px] mt-[5px] ">
          {job.job_type || job[locale]?.job_type}
        </p>
      </div>

      {/* extra job details  */}

      <div className="mt-4 [&>*]:space-x-3 space-y-[10px] relative w-full">
        {/* positions */}
        <div className="flex gap-x-[5px]">
          <Bag />
          <p className="font-[510] truncate text-[12px] text-[#36A9E1] leading-[26px]">
            {job.count >= 2
              ? job.count + " " + t("YOE")
              : job.count + " " + t("OYOE")}
          </p>
        </div>

        <div className="flex gap-x-[5px]">
          <span className="opacity-30 ">
            <Calender />
          </span>

          <p className="font-[510] text-[12px] text-[#010140] leading-[26px] ">
            {date}
          </p>
        </div>

        <div className=" absolute w-full bottom-0 h-[56px] right-0 flex justify-end  ">
          <Link href={`/careers/${job?._id}`} className="z-10 relative">
            <button
              className="w-[56px] h-[56px] rounded-full bg-[#6D2E88] flex justify-center items-center"
              style={{
                transform: locale == "ar" ? "rotate(180deg)" : "",
              }}
            >
              <Arrow />
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CareerCard;
